import Vue from 'vue';

Vue.directive('color-text-change', {
    bind(el, binding) {
        // Here, `el` is the element the directive is bound to
        // `binding.value` will be the value you passed to the directive
        handleTextColorChangeOnElement(el, binding.value);
    },
    update(el, binding) {
        // Called when the value of the directive changes
        handleTextColorChangeOnElement(el, binding.value);
    },
});

function handleTextColorChangeOnElement(el, typeColor) {
    // Here, you can manipulate `el` directly
    el.style.color = typeColor;
}
